import EfScrollAni from '@/efscrollani';
import { IPageStatus } from '../../config/IPageStatus';
import { useProductStore } from '../../ProductProvider';
import styles from './index.module.scss';
import StatusA from './StatusA';

export default function ExampleProductA() {
    const { pageStatus } = useProductStore();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    return (
        <div className={`${styles.PageProduct} trail-series`}>
            <StatusA />
        </div>
    );
}
